module.exports = __webpack_public_path__ + "img/profit-right-comtent-bg.fc302f57.png";